var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M53 60.5L74.9999 37.5M53 15.5L74.9999 37.5M74.9999 37.5L1.20573e-07 37.5","stroke":"black"}));
}

Arrow.defaultProps = {"width":"76","height":"76","viewBox":"0 0 76 76","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
